import { DataCardinalityEnum } from '../../../shared/enums/data-cardinality.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { ApiRequestOrdering } from '../../../shared/types/api-request-ordering';
import { ReportJobListDto } from '../../report-jobs/dtos/report-job-list.dto';
import { ReportTemplateRecordDto } from '../../report-templates/dtos/report-template-record.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { ReportScheduleTypeEnum } from '../enums/report-schedule-type.enum';
import { ReportStatusEnum } from '../enums/report-status.enum';
import { ReportTypeEnum } from '../enums/report-type.enum';

import { ReportVariableDto } from './report-variable.dto';

/**
 * Report DTO for records
 */
@CaslSubject(AppSubjectEnum.REPORT)
export class ReportRecordDto extends BaseDto {
	name!: string;
	status!: ReportStatusEnum;
	title?: string;
	subTitle?: string;
	description?: string;
	notes?: string;
	isSystem!: boolean;
	type!: ReportTypeEnum;
	cardinality!: DataCardinalityEnum;
	scheduleType!: ReportScheduleTypeEnum;
	scheduleAt?: Date;
	scheduleCron?: string;
	filters?: ApiRequestFilters;
	ordering?: ApiRequestOrdering;
	templateId?: number;
	template?: ReportTemplateRecordDto;
	variables?: ReportVariableDto[];
	jobs?: ReportJobListDto[];
	tags?: TagListDto[];
}
